// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import qs from 'qs'
import { Switch, Route, withRouter } from 'react-router-dom'
import store from './state/store'
import { fetchClient } from './state/client/actions'
import { restoreLearner } from './state/learner/actions'
import styled from 'styled-components'
import { isProduction } from './utils'

import {
  QuizScreen,
  StartScreen,
  CompleteScreen,
  InformationScreen,
  InstructionsScreen,
  CommencementCheckScreen,
  LearnerFormScreen,
  DeclarationScreen,
  WelcomeBackScreen,
  IntermissionScreen,
  MissScreen,
  QuizDisabledScreen,
  QuizTypeDisabledScreen,
  DlrqQuizScreen,
  DlrqStartScreen,
  DlrqCompleteScreen,
  DlrqLearnerFormScreen,
  DlrqInfoScreen
} from './screens'

import UnsupportedBrowerWarning from './lib/check-browser-compatability'
import { fetchCourses } from './state/courses/actions'

// min-height: 625px;
// min-width: 980px;
const dlrqPath = [
  '/dlrq',
  '/dlrq-learner-form',
  '/dlrq-start',
  '/dlrq-information',
  '/dlrq-complete'
]
const Base = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #2C9DA3;
  ${({currentPath}) => {
    if (dlrqPath.indexOf(currentPath) >= 0) {
      return `overflow-y: auto;`;
    } else {
      return `@media (max-width: 1024px), (max-height: 768px) {
        transform: scale(0.8);
        transform-origin: left top;
        width: 125%;
        height: 125%;
      }

      @media (max-width: 800px), (max-height: 600px) {
        transform: scale(0.7);
        transform-origin: left top;
        width: 142.85%;
        height: 142.85%;
      }`
    }
  }}
`

/**
 * Top-level components, composes all screens
 * @memberof components/Screens
 */
class App extends Component {
  componentDidMount() {
    // Initialise the client
    this.props.fetchClient()
    // Initialise the learner
    const { invite, goToQuestion } = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    })
    if (invite) {
      this.props.restoreLearner(invite)
    }
    this.props.fetchCourses()
    if (!isProduction() && goToQuestion != null) {
      store.dispatch({
        type: 'SUBMIT_ANSWER_PENDING',
        payload: {
          answer: { questionId: 'mock', answer: { mock: true } },
          nextQuestionRequest: goToQuestion,
        },
      })
      this.props.history.push('/quiz')
    }
  }
  render() {
    return (
      <Base currentPath={this.props.location.pathname}>
        <UnsupportedBrowerWarning />
        <Switch>
          <Route path="/" exact component={StartScreen} />
          <Route path="/complete" component={CompleteScreen} />
          <Route path="/information" component={InformationScreen} />
          <Route path="/instructions" component={InstructionsScreen} />
          <Route
            path="/commencement-check"
            component={CommencementCheckScreen}
          />
          <Route path="/learner-form" component={LearnerFormScreen} />
          <Route path="/dlrq-learner-form" component={DlrqLearnerFormScreen} />
          <Route path="/declaration" component={DeclarationScreen} />
          <Route path="/welcome-back" component={WelcomeBackScreen} />
          <Route path="/disabled" component={QuizDisabledScreen} />
          <Route path="/type-disabled" component={QuizTypeDisabledScreen} />
          <Route path="/intermission" component={IntermissionScreen} />
          <Route path="/quiz" component={QuizScreen} />
          <Route path="/dlrq" component={DlrqQuizScreen} />
          <Route path="/dlrq-start" component={DlrqStartScreen} />
          <Route path="/dlrq-information" component={DlrqInfoScreen} />
          <Route path="/dlrq-complete" component={DlrqCompleteScreen} />
          <Route component={MissScreen} />
        </Switch>
      </Base>
    )
  }
}

// wrapping with router here to force an update of the component
// see discussion https://github.com/reactjs/react-redux/issues/507 for details
export default withRouter(connect(null, { fetchClient, restoreLearner, fetchCourses })(App))



// WEBPACK FOOTER //
// ./src/App.js